import { createSelector } from 'reselect';
import { resourceSelectors } from '../../utils/resourceSelectors';

export const [usersAllIdsSelector, usersByIdSelector, allUsersSelector] =
  resourceSelectors('users');

export const userByIdSelector = (id) =>
  createSelector(usersByIdSelector, (byId) => byId[id]);
